.link {
  cursor: pointer;

  &.underline-never,
  &.underline-false {
    text-decoration: none;
  }

  &.underline-always,
  &.underline-true {
    text-decoration: underline;
  }

  &.underline-onHover {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.no-visited-coloring {
  /* avoid coloring visited links */
  color: inherit;
}
